// extracted by mini-css-extract-plugin
module.exports =  {"btn-wrapper":"urlInput__btn-wrapper","line":"urlInput__line","input-text":"urlInput__input-text"};